import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ChangeRequestDetailsState {
  currentStep: number;
}

const initialState: ChangeRequestDetailsState = {
  currentStep: 0,
};

const changeRequestStepsSlice = createSlice({
  name: 'changeRequestSteps',
  initialState,
  reducers: {
    resetChangeRequestSteps: () => {
      return initialState;
    },
    updateCurrentStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
  },
});

export const { resetChangeRequestSteps, updateCurrentStep } =
  changeRequestStepsSlice.actions;
export default changeRequestStepsSlice.reducer;
